module.exports = __webpack_public_path__ + "static/img/img_logo.69a4084.png";


//////////////////
// WEBPACK FOOTER
// ./static/onLineContractSign/img_logo.png
// module id = 7NTe
// module chunks = 83